// @NOTE: This function is split from merchantos.print class so it doesn't bundle unwanted files
// into the compile_map for printTemplates.js files used for receipt/label template iframes.
// Since there are many includes in the merchantos.print class file, a huge bundle was created
// and loaded when printing templates (it has other side effects such as creating a redux store and
// initializing an Ably connection). All the iframe needs is this simple function for webpos and RM.

/**
 * Handles print requests from within the Print Templates.
 * @param {('label' | 'receipt' | 'report')} pageType "receipt", "label" or "report"
 * @returns {boolean}
 */
const printTemplate = (pageType: PageType) => {
  const url = window.location.href;
  // TODO: Handle cases here and in other places for label printing

  if (window.isGriffin() && pageType === 'receipt') {
    window.flashNotifier('working', 'Printing', 4);
    const receiptInfo = window.StencilWebAPI.printer.printJob(url, false);
    window.StencilWebAPI.printer.print(receiptInfo);
  } else {
    window.print();
  }
  return true;
};

const getSaleIdFromUrl = (url: string) => {
  const [, saleID] = /Sale\/(\d+)\.(?:html|json)/.exec(url) || [];
  return saleID;
};

export { printTemplate, getSaleIdFromUrl as getSaleId };

if (!window.merchantos.print) {
  // @ts-ignore This is only going to be included on the print template url,
  // we're including this function to accommodate overridden templates and Stencil
  window.merchantos.print = { print: printTemplate };
}
